var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-icon',{key:_vm.name,attrs:{"name":_vm.nameComputed,"width":_vm.width,"height":_vm.height,"original":_vm.original,"alt":_vm.altText,"color":_vm.color,"fill":_vm.fill}})}
var staticRenderFns = []

export { render, staticRenderFns }